export function guvenBandiHesapla(orneklem, esikler = { yuksek: 80, orta: 25 }) {
  const n = Number(orneklem || 0);
  if (n >= Number(esikler.yuksek || 80)) return 'YÜKSEK';
  if (n >= Number(esikler.orta || 25)) return 'ORTA';
  return 'DÜŞÜK';
}

export function katsayiHesapla(guvenBandi, orneklem, esikler = { yuksek: 80, orta: 25 }) {
  const guven = String(guvenBandi || 'DÜŞÜK').toLocaleUpperCase('tr-TR');
  const n = Number(orneklem || 0);
  const yuksekEsik = Number(esikler.yuksek || 80);
  const ortaEsik = Number(esikler.orta || 25);

  const guvenKatsayisi = guven === 'YÜKSEK' ? 1 : guven === 'ORTA' ? 0.75 : 0.45;
  const orneklemKatsayisi = n >= yuksekEsik ? 1 : n >= ortaEsik ? 0.75 : 0.4;

  return { guvenKatsayisi, orneklemKatsayisi };
}

export function aksiyonSkoruHesapla(etkiPuani, guvenBandi, orneklem, esikler) {
  const { guvenKatsayisi, orneklemKatsayisi } = katsayiHesapla(guvenBandi, orneklem, esikler);
  return Number((Number(etkiPuani || 0) * guvenKatsayisi * orneklemKatsayisi).toFixed(2));
}

export function aksiyonKilidiHesapla({
  anomaliSayisi = 0,
  guvenBandi = 'DÜŞÜK',
  dusukOrneklemKilidi = false,
  anomaliMesaji = 'Bu aksiyon şu an uygulanamaz: veri tutarsızlığı giderilmeden canlıya alınmamalı.',
  dusukOrneklemMesaji = 'Bu aksiyon şu an uygulanamaz: örneklem düşük, önce gözlem modunda izlenmeli.'
}) {
  if (Number(anomaliSayisi || 0) > 0) {
    return { actionLock: true, actionLockReason: anomaliMesaji };
  }
  if (dusukOrneklemKilidi || String(guvenBandi || '').toLocaleUpperCase('tr-TR') === 'DÜŞÜK') {
    return { actionLock: true, actionLockReason: dusukOrneklemMesaji };
  }
  return { actionLock: false, actionLockReason: '' };
}

export function aksiyonlaraKilitUygula(actions = [], actionLock = false, actionLockReason = '') {
  return actions.map((action) => ({
    ...action,
    enabled: actionLock ? false : action.enabled !== false,
    lockReason: action.lockReason || actionLockReason
  }));
}
